var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.key,staticClass:"box"},[_c('p',{staticClass:"risk-tip"},[_vm._v(_vm._s(_vm.riskText))]),(_vm.imageInfo.url )?_c('img',{staticClass:"image",attrs:{"src":_vm.imageInfo.url,"width":"100%","alt":_vm.statusText}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }